module.exports = __webpack_public_path__ + "static/media/defillama.a7f4801f.svg";